import API from "../api"; 
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [phone, setPhone] = useState(""); 
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); 
    try {
      const res = await API.post("/auth/login", { phone, password });

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        alert("Admin Access Granted! 🔓");
        navigate("/admin"); 
      }
    } catch (err) {
      console.error("Login Error:", err.response?.data);
      alert(err.response?.data?.message || "Invalid Phone or Password");
    }
  };

  return (
    <div style={{ padding: 40, maxWidth: 400, margin: "100px auto", textAlign: "center", border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "#fff" }}>
      <h2>Admin Login 🔐</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          required
          style={inputStyle}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={inputStyle}
        />
        <button type="submit" style={btnStyle}>Login to Dashboard</button>
      </form>
    </div>
  );
}

const inputStyle = { width: "100%", padding: "12px", marginBottom: "15px", borderRadius: "5px", border: "1px solid #ccc", boxSizing: "border-box" };
const btnStyle = { width: "100%", padding: "12px", background: "#000", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" };

export default AdminLogin;